export class TooltipDescription {
    constructor(
    public  TooltipDerogatory: string,
        public TooltipLoansGuaranteedRate: string,
        public TooltipLoansVariableRate: string  ,
        public TooltipAccountOverviewDebts: string ,
        public TooltipAccountOverviewConnectedAccounts: string  ,
        public TooltipForPreApproved100: string
    ) {}
}